import type { ValidationError } from "@hubrise/react-components"

import { useConfig } from "shared/components/ConfigContext"
import { axiosServer } from "shared/utils/server"

type ImageUploadFn = (blob: Blob, catalogId: string) => Promise<string>

const useImageUpload = (): ImageUploadFn => {
  const { appInstanceId } = useConfig()

  return async (blob, catalogId) => {
    const { status, data } = await axiosServer<{ id: string } & ValidationError>(
      "POST",
      `/images/${catalogId}`,
      appInstanceId,
      {
        data: blob,
        headers: { "Content-Type": blob.type },
        validateStatus: () => true,
      },
    )
    switch (status) {
      case 200:
        return data.id
      case 422:
        throw data.errors
          .map(({ field, message }: { field: string; message: string }) => `${field} ${message}`)
          .join(" - ")
      default:
        throw data
    }
  }
}

export default useImageUpload
